const colors = {
    primary: '#1C1463',
    secondary: '#22B573',
    primaryLight: '#1B1464',
};
export default colors;
